export default "__VITE_ASSET__CqYEVq6Z__"